import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@ui/dialog-v2/dialog.tokens';
import {
    AbstractNoteFormBody,
    FormAbstractNoteComponent,
} from '@ui/base/form-abstract-note/form-abstract-note.component';
import { takeUntil } from 'rxjs/operators';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { AsyncPipe } from '@angular/common';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'popup-confirm-with-note-dialog',
    templateUrl: './confirm-with-note-dialog.component.html',
    styleUrls: ['./confirm-with-note-dialog.component.scss'],
    imports: [
        FormAbstractNoteComponent,
        AsyncPipe,
    ],
})
export class ConfirmWithNoteDialogComponent {
    readonly #push: PushService = inject(PushService);
    readonly #data: DialogData = inject(MAT_DIALOG_DATA);

    public readonly pending$: Observable<boolean> | undefined =
        this.#data.params?.pending$;

    public readonly noteRequired: boolean | undefined = this.#data.params?.noteRequired;
    public readonly resetFieldAfterSubmit: boolean | undefined = this.#data.params?.resetFieldAfterSubmit;
    private readonly destroy$: Subject<unknown> = new Subject<unknown>();

    constructor(
        public dialogRef: MatDialogRef<ConfirmWithNoteDialogComponent>,
    ) {
    }

    public handlerClickConfirm(body: AbstractNoteFormBody): void {
        this.#data.params
            .confirmFunction(body.note)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.#push.success(PushCodeModel.SuccessDelete);
                this.handlerClickCancel();
            });
    }

    public handlerClickCancel(): void {
        this.dialogRef.close();
    }

    public ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
